import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faSquareMinus } from '@fortawesome/pro-light-svg-icons';

export type ProLightSquareMinusProps = IconComponentProps;

export const ProLightSquareMinus = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightSquareMinusProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faSquareMinus}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faSquareMinus}
    />
  );
};

ProLightSquareMinus.displayName = 'ProLightSquareMinus';
